import {
  // SET_BIND_STATUS,
  SET_BACK_URL,
  // LOG_IN,
  // USERS_BY_MOBILE,
  FETCH_LOGIN_INFO,
  // BIND_MOBILE,
  // UNBIND_MOBILE,
  // SET_TOAST_MSG,
} from '../constants';


export default function runtime(state = {
  // bindshow: false,
  // needbind: false,
  backurl: '/',
  // mbloginstatus: {},
  // userinfobymb: [],
  // bindstatus: {},
  // unbindstatus: {},
  logininfo: {},
}, action) {
  switch (action.type) {
    // case SET_BIND_STATUS:
    //   return {
    //     ...state,
    //     ...action.data,
    //   }
    case SET_BACK_URL:
      return {
        ...state,
        backurl: action.backurl,
      }
    // case LOG_IN:
    //   return {
    //     ...state,
    //     mbloginstatus: action.data,
    //   }
    // case USERS_BY_MOBILE:
    //   return {
    //     ...state,
    //     userinfobymb: action.data.result.filter(
    //       item => !/^urs-phoneyd.*@163.com$/.test(item.userId),
    //     ),
    //   }
    case FETCH_LOGIN_INFO:
      return {
        ...state,
        logininfo: action.data,
      }

    // case UNBIND_MOBILE:
    //   return {
    //     ...state,
    //     unbindstatus: action.data,
    //   }
    // case SET_TOAST_MSG:
    //   return {
    //     ...state,
    //     toastmsg: action.data,
    //   }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js